import './gallery.scss'

export default function Gallery() {
  return (
    <div id="gallery">
      <h1>check out some websites designed by minnedev</h1>
      <h2>Coming Soon</h2>
    </div>
  )
}